import _createClass from "@babel/runtime/helpers/createClass";
import { settingTopEntrySymbol } from '../symbols';
import { Node as ShellNode } from './node';
import { SettingField } from './setting-field';
export var SettingTopEntry = /*#__PURE__*/function () {
  function SettingTopEntry(prop) {
    this[settingTopEntrySymbol] = void 0;
    this[settingTopEntrySymbol] = prop;
  }
  SettingTopEntry.create = function create(prop) {
    return new SettingTopEntry(prop);
  }

  /**
   * 返回所属的节点实例
   */;
  var _proto = SettingTopEntry.prototype;
  /**
   * 获取子级属性对象
   * @param propName
   * @returns
   */
  _proto.get = function get(propName) {
    return SettingField.create(this[settingTopEntrySymbol].get(propName));
  }

  /**
   * @deprecated use .node instead
   */;
  _proto.getNode = function getNode() {
    return this.node;
  }

  /**
   * 获取指定 propName 的值
   * @param propName
   * @returns
   */;
  _proto.getPropValue = function getPropValue(propName) {
    return this[settingTopEntrySymbol].getPropValue(propName);
  }

  /**
   * 设置指定 propName 的值
   * @param propName
   * @param value
   */;
  _proto.setPropValue = function setPropValue(propName, value) {
    this[settingTopEntrySymbol].setPropValue(propName, value);
  };
  _proto.clearPropValue = function clearPropValue(propName) {
    this[settingTopEntrySymbol].clearPropValue(propName);
  };
  _createClass(SettingTopEntry, [{
    key: "node",
    get: function get() {
      return ShellNode.create(this[settingTopEntrySymbol].getNode());
    }
  }]);
  return SettingTopEntry;
}();